export default function LineNumberReader() {}